// src/registerServiceWorker.js
import { Workbox } from 'workbox-window'
import logger from '@/logger'

let wb = null
const MIN_UPDATE_INTERVAL_MS = 60 * 1000
let lastUpdateCheck = 0

export function requestSwUpdate (reason = '') {
  if (!wb || typeof wb.update !== 'function') return

  const now = Date.now()

  if (now - lastUpdateCheck >= MIN_UPDATE_INTERVAL_MS) {
    lastUpdateCheck = now
    logger.debug(`Atualizando SW... ${reason}`.trim())
    wb.update()
  } else {
    logger.debug(
      `Checagem de SW ignorada (intervalo < 1 min) ${reason}`.trim()
    )
  }
}

if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  wb = new Workbox(`${process.env.BASE_URL}service-worker.js`)

  // Ao retornar do background (visibilidade da aba)
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      requestSwUpdate('- Página voltou ao foco')
    }
  })

  // Quando o SW instalar uma nova versão mas fica em waiting
  wb.addEventListener('waiting', () => {
    wb.messageSW({ type: 'SKIP_WAITING' })
  })

  // Quando o SW estiver controlando a página
  wb.addEventListener('controlling', () => {
    logger.debug('Novo SW controlando, recarregando…')
    window.location.reload()
  })

  wb.register()
}
export default wb
